import { MAX_REQUESTED_VENUES } from '../../Constants'
import captureMessage from '../Errors/captureMessage'

const STORAGE_KEY = 'hb-shortlist'

export const SHORTLIST_QUERY_PARAM = 'shortlist'

const toSpaceIds = (values: string[]): number[] => {
  const ids = values
    .flatMap((value) => value.split(','))
    .map((value) => Number(value.trim()))
    .filter((id) => Number.isInteger(id) && id > 0)

  return [...new Set(ids)].slice(0, MAX_REQUESTED_VENUES)
}

export const getShortlistParam = (params: URLSearchParams): number[] =>
  toSpaceIds(params.getAll(SHORTLIST_QUERY_PARAM))

export const getStoredShortlist = (): number[] => {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (!stored) return []

  try {
    const ids: unknown = JSON.parse(stored)
    if (!Array.isArray(ids)) throw new Error(`Unrecognised entity stored under '${STORAGE_KEY}'`)

    return toSpaceIds(ids.map(String))
  } catch (error) {
    captureMessage(error instanceof Error ? error.message : String(error))
    return []
  }
}

export const setStoredShortlist = (spaceIds: number[]): void =>
  localStorage.setItem(STORAGE_KEY, JSON.stringify(spaceIds))

export const captureShortlistFromURL = (): void => {
  const spaceIds = getShortlistParam(new URLSearchParams(window.location.search))

  if (spaceIds.length) setStoredShortlist(spaceIds)
}

export const clearStoredShortlist = (): void => localStorage.removeItem(STORAGE_KEY)
